import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SupportChatbotService {
  readonly open = signal(false);

  openPanel() { this.open.set(true); }
  toggle() { this.open.update((v) => !v); }
}
